import ConfluenceHomeBannerPlacementSkeleton from '@post-office-placement/confluence-home-banner/skeleton';

import { LoadableAfterPaint } from '@confluence/loadable';

export const PostOfficeHomeBanner = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PostOfficeHomeBanner" */ '../src'))
			.PostOfficeHomeBanner,
	loading: ConfluenceHomeBannerPlacementSkeleton,
});
